<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <router-link class="btn btn-success" :to="{ name: 'plan' }" tag="button">{{
        'routes_plan_create' | t
      }}</router-link>
    </div>
    <div class="card">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <template v-if="!isWhiteLabel">
              <th>{{ 'billing_period' | t }}</th>
              <th>tier</th>
              <th>{{ 'plan_group' | t }}</th>
              <th>{{ 'currency' | t }}</th>
              <th v-if="can('read_organizations')">{{ 'organization' | t }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <router-link
            :to="{ name: 'edit_plan', params: { plan_id: plan.id } }"
            tag="tr"
            v-for="plan in plans"
            :key="plan.id"
            role="button"
          >
            <td>
              <span>{{ plan.name }}</span
              ><span class="badge badge-warning ml-2" v-if="can('read_organizations') && plan.generation == 1"
                >Legacy</span
              >
            </td>
            <template v-if="!isWhiteLabel">
              <td>{{ plan.billing_period | t }}</td>
              <td>{{ plan.tier }}</td>
              <td>{{ plan.plan_group }}</td>
              <td>{{ plan.currency }}</td>
              <td v-if="can('read_organizations')">
                <span v-if="plan.organization">{{ plan.organization.name }}</span>
              </td>
            </template>
          </router-link>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      plans: []
    };
  },
  methods: {},
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'plans' }, text: 'Plans' }]);
    Api.findAllPages('plans', { include: 'organization' }).then(({ data }) => {
      this.plans = data;
    });
  }
};
</script>

<style scoped></style>
